import {
  ConfiguratorEngagementPackage,
  ConfiguratorThemeArtOption,
  ConfiguratorTrafficDetails,
  ConfiguratorTrafficPackage,
} from './types';

const RANDOM_MOCK_API_DELAY = Math.floor(Math.random() * (2000 - 500 + 1)) + 500;

export function getThemeArtMockData(): Promise<ConfiguratorThemeArtOption[]> {
  return new Promise((resolve) => {
    const data: ConfiguratorThemeArtOption[] = [
      {
        id: 'photography_1',
        name: {
          en: 'Photography 1',
        },
        imageUrl: 'https://micros-t.b-cdn.net/photography1%402x-1747060385949.png',
      },
      {
        id: 'photography_2',
        name: {
          en: 'Photography 2',
        },
        imageUrl: 'https://micros-t.b-cdn.net/photography2%402x-1747060385830.png',
      },
      {
        id: 'photography_3',
        name: {
          en: 'Photography 3',
        },
        imageUrl: 'https://micros-t.b-cdn.net/photography3%402x-1747060401539.png',
      },
      {
        id: 'illustration_1',
        name: {
          en: 'Illustration 1',
        },
        imageUrl: 'https://micros-t.b-cdn.net/illustration1%402x-1747060385990.png',
      },
      {
        id: 'illustration_2',
        name: {
          en: 'Illustration 2',
        },
        imageUrl: 'https://micros-t.b-cdn.net/illustration2%402x-1747060385872.png',
      },
      {
        id: 'neon_1',
        name: {
          en: 'Neon 1',
        },
        imageUrl: 'https://micros-t.b-cdn.net/neon%402x-1747060385874.png',
      },
      {
        id: 'neon_2',
        name: {
          en: 'Neon 2',
        },
        imageUrl: 'https://micros-t.b-cdn.net/neonnext%402x-1747060385766.png',
      },
      {
        id: 'classic_casino',
        name: {
          en: 'Classic Casino',
        },
        imageUrl: 'https://micros-t.b-cdn.net/classiccasino%402x-1747060385798.png',
      },
      {
        id: '3d',
        name: {
          en: '3D',
        },
        imageUrl: 'https://micros-t.b-cdn.net/3d%402x-1747060385709.png',
      },
      {
        id: 'cartoon',
        name: {
          en: 'Cartoon',
        },
        imageUrl: 'https://micros-t.b-cdn.net/cartoon%402x-1747060385671.png',
      },
      {
        id: 'minimalist',
        name: {
          en: 'Minimalist',
        },
        imageUrl: 'https://micros-t.b-cdn.net/sunset%402x-1747060385649.png',
      },
    ];

    setTimeout(() => resolve(data), RANDOM_MOCK_API_DELAY);
  });
}

export function getEngagementPackagesMockData(): Promise<ConfiguratorEngagementPackage[]> {
  return new Promise((resolve) => {
    const data: ConfiguratorEngagementPackage[] = [
      {
        id: 'loyalty_shop_1',
        name: {
          en: 'Loyalty Shop #1',
        },
        description: {
          en: 'Daily offering of grand prizes for your most loyal users.',
        },
        imageUrl: '',
        levels: [
          {
            id: 'level_1',
            name: {
              en: 'Level 1',
            },
            description: {
              en: 'Add a daily offering of grand prizes for your most loyal users. Add a daily offering of grand prizes for your most loyal users. Add a daily offering of grand prizes for your most loyal users.',
            },
            price: 59,
            currency: 'USD',
            discount: 0,
            benefits: [
              {
                name: {
                  en: 'These prizes are exclusively available',
                },
              },
              {
                name: {
                  en: 'These prizes are exclusively available in the loyalty shop',
                },
              },
              {
                name: {
                  en: 'A powerful tool to increase user stickiness and daily engagement',
                },
              },
              {
                name: {
                  en: 'These prizes are exclusively available in the loyalty shop',
                },
              },
            ],
          },
          {
            id: 'level_2',
            name: {
              en: 'Level 2',
            },
            description: {
              en: '',
            },
            price: 69,
            currency: 'USD',
            discount: 0,
            benefits: [
              {
                name: {
                  en: 'Level 1 benefits included',
                },
              },
              {
                name: {
                  en: 'These prizes are exclusively available',
                },
              },
              {
                name: {
                  en: 'These prizes are exclusively available in the loyalty shop',
                },
              },
              {
                name: {
                  en: 'A powerful tool to increase user stickiness and daily engagement',
                },
              },
              {
                name: {
                  en: 'These prizes are exclusively available in the loyalty shop',
                },
              },
            ],
          },
          {
            id: 'level_3',
            name: {
              en: 'Level 3',
            },
            description: {
              en: '',
            },
            price: 99,
            currency: 'USD',
            discount: 20,
            benefits: [
              {
                name: {
                  en: 'Level 1 & 2 benefits included',
                },
              },
              {
                name: {
                  en: 'These prizes are exclusively available',
                },
              },
              {
                name: {
                  en: 'These prizes are exclusively available in the loyalty shop',
                },
              },
              {
                name: {
                  en: 'A powerful tool to increase user stickiness and daily engagement',
                },
              },
              {
                name: {
                  en: 'These prizes are exclusively available in the loyalty shop',
                },
              },
            ],
          },
        ],
      },
      {
        id: 'loyalty_shop_2',
        name: {
          en: 'Loyalty Shop #2',
        },
        description: {
          en: 'Daily offering of grand prizes for your most loyal users.',
        },
        imageUrl: '',
        levels: [
          {
            id: 'level_1',
            name: {
              en: 'Level 1',
            },
            description: {
              en: 'Add a daily offering of grand prizes for your most loyal users. Add a daily offering of grand prizes for your most loyal users. Add a daily offering of grand prizes for your most loyal users.',
            },
            price: 59,
            currency: 'USD',
            discount: 0,
            benefits: [
              {
                name: {
                  en: 'These prizes are exclusively available',
                },
              },
              {
                name: {
                  en: 'These prizes are exclusively available in the loyalty shop',
                },
              },
              {
                name: {
                  en: 'A powerful tool to increase user stickiness and daily engagement',
                },
              },
              {
                name: {
                  en: 'These prizes are exclusively available in the loyalty shop',
                },
              },
            ],
          },
          {
            id: 'level_2',
            name: {
              en: 'Level 2',
            },
            description: {
              en: '',
            },
            price: 69,
            currency: 'USD',
            discount: 0,
            benefits: [
              {
                name: {
                  en: 'Level 1 benefits included',
                },
              },
              {
                name: {
                  en: 'These prizes are exclusively available',
                },
              },
              {
                name: {
                  en: 'These prizes are exclusively available in the loyalty shop',
                },
              },
              {
                name: {
                  en: 'A powerful tool to increase user stickiness and daily engagement',
                },
              },
              {
                name: {
                  en: 'These prizes are exclusively available in the loyalty shop',
                },
              },
            ],
          },
          {
            id: 'level_3',
            name: {
              en: 'Level 3',
            },
            description: {
              en: '',
            },
            price: 99,
            currency: 'USD',
            discount: 20,
            benefits: [
              {
                name: {
                  en: 'Level 1 & 2 benefits included',
                },
              },
              {
                name: {
                  en: 'These prizes are exclusively available',
                },
              },
              {
                name: {
                  en: 'These prizes are exclusively available in the loyalty shop',
                },
              },
              {
                name: {
                  en: 'A powerful tool to increase user stickiness and daily engagement',
                },
              },
              {
                name: {
                  en: 'These prizes are exclusively available in the loyalty shop',
                },
              },
            ],
          },
        ],
      },
      {
        id: 'loyalty_shop_3',
        name: {
          en: 'Loyalty Shop #3',
        },
        description: {
          en: 'Daily offering of grand prizes for your most loyal users.',
        },
        imageUrl: '',
        levels: [
          {
            id: 'level_1',
            name: {
              en: 'Level 1',
            },
            description: {
              en: 'Add a daily offering of grand prizes for your most loyal users. Add a daily offering of grand prizes for your most loyal users. Add a daily offering of grand prizes for your most loyal users.',
            },
            price: 59,
            currency: 'USD',
            discount: 0,
            benefits: [
              {
                name: {
                  en: 'These prizes are exclusively available',
                },
              },
              {
                name: {
                  en: 'These prizes are exclusively available in the loyalty shop',
                },
              },
              {
                name: {
                  en: 'A powerful tool to increase user stickiness and daily engagement',
                },
              },
              {
                name: {
                  en: 'These prizes are exclusively available in the loyalty shop',
                },
              },
            ],
          },
          {
            id: 'level_2',
            name: {
              en: 'Level 2',
            },
            description: {
              en: '',
            },
            price: 69,
            currency: 'USD',
            discount: 0,
            benefits: [
              {
                name: {
                  en: 'Level 1 benefits included',
                },
              },
              {
                name: {
                  en: 'These prizes are exclusively available',
                },
              },
              {
                name: {
                  en: 'These prizes are exclusively available in the loyalty shop',
                },
              },
              {
                name: {
                  en: 'A powerful tool to increase user stickiness and daily engagement',
                },
              },
              {
                name: {
                  en: 'These prizes are exclusively available in the loyalty shop',
                },
              },
            ],
          },
          {
            id: 'level_3',
            name: {
              en: 'Level 3',
            },
            description: {
              en: '',
            },
            price: 99,
            currency: 'USD',
            discount: 20,
            benefits: [
              {
                name: {
                  en: 'Level 1 & 2 benefits included',
                },
              },
              {
                name: {
                  en: 'These prizes are exclusively available',
                },
              },
              {
                name: {
                  en: 'These prizes are exclusively available in the loyalty shop',
                },
              },
              {
                name: {
                  en: 'A powerful tool to increase user stickiness and daily engagement',
                },
              },
              {
                name: {
                  en: 'These prizes are exclusively available in the loyalty shop',
                },
              },
            ],
          },
        ],
      },
    ];

    setTimeout(() => resolve(data), RANDOM_MOCK_API_DELAY);
  });
}

export function getTrafficDetailsMockData(): Promise<ConfiguratorTrafficDetails> {
  return new Promise((resolve) => {
    const data: ConfiguratorTrafficDetails = {
      siteName: 'BetPlaces.com',
      totalPlayers: 150555,
      totalBets: 11887999,
      totalDeposits: 150555,
      topPlayers: [
        {
          siteUrl: 'https://www.888.ro/',
          siteImageUrl: 'https://micros-t.b-cdn.net/logo-casino-1724323490206.svg',
          game: 'Plinko',
          user: 'User1134566',
          played: (13 * 60 * 60 + 45 * 60 + 44) * 1000, // 13 hours, 45 minutes, 44 seconds
          earnings: 2576,
        },
        {
          siteUrl: 'https://www.888.ro/',
          siteImageUrl: 'https://micros-t.b-cdn.net/logo-casino-1724323490206.svg',
          game: 'Plinko',
          user: 'User1134566',
          played: (13 * 60 * 60 + 45 * 60 + 44) * 1000, // 13 hours, 45 minutes, 44 seconds
          earnings: 2576,
        },
        {
          siteUrl: 'https://www.888.ro/',
          siteImageUrl: 'https://micros-t.b-cdn.net/logo-casino-1724323490206.svg',
          game: 'Plinko',
          user: 'User1134566',
          played: (13 * 60 * 60 + 45 * 60 + 44) * 1000, // 13 hours, 45 minutes, 44 seconds
          earnings: 2576,
        },
        {
          siteUrl: 'https://www.888.ro/',
          siteImageUrl: 'https://micros-t.b-cdn.net/logo-casino-1724323490206.svg',
          game: 'Plinko',
          user: 'User1134566',
          played: (13 * 60 * 60 + 45 * 60 + 44) * 1000, // 13 hours, 45 minutes, 44 seconds
          earnings: 2576,
        },
        {
          siteUrl: 'https://www.888.ro/',
          siteImageUrl: 'https://micros-t.b-cdn.net/logo-casino-1724323490206.svg',
          game: 'Plinko',
          user: 'User1134566',
          played: (13 * 60 * 60 + 45 * 60 + 44) * 1000, // 13 hours, 45 minutes, 44 seconds
          earnings: 2576,
        },
      ],
    };

    setTimeout(() => resolve(data), RANDOM_MOCK_API_DELAY);
  });
}

export function getTrafficPackagesMockData(): Promise<ConfiguratorTrafficPackage[]> {
  return new Promise((resolve) => {
    const data: ConfiguratorTrafficPackage[] = [
      {
        id: 'traffic_pack_1',
        name: {
          en: 'Lite',
        },
        description: {
          en: "The ideal package for newcomers. This package includes all the tools you'll need to quickly get your casino off the ground and running!",
        },
        imageUrl: '',
        price: 79,
        currency: 'USD',
        discount: 0,
        perks: [
          {
            name: {
              en: 'Loyalty & Shop - Bronze',
            },
            description: {
              en: 'Play activity ear loyalty points that can be redeemed for unique prizes.',
            },
            imageUrl: 'https://micros-t.b-cdn.net/present-bronze-1748016818440.svg',
          },
          {
            name: {
              en: 'Jackpot - Bronze',
            },
            description: {
              en: 'Mystery jackpot with a single prize tier.',
            },
            imageUrl: 'https://micros-t.b-cdn.net/piggy-bronze-1748016818437.svg',
          },
          {
            name: {
              en: 'Tournaments (Casino + SB) - Bronze',
            },
            description: {
              en: 'Basic tournament with a small prize pool for top 30 players.',
            },
            imageUrl: 'https://micros-t.b-cdn.net/wheel-bronze-1748016827517.svg',
            requirement: {
              name: {
                en: 'Requires Loyalty level 1 or better',
              },
              pack: 'loyalty_shop_1',
              level: 'level_1',
            },
          },
        ],
      },
      {
        id: 'traffic_pack_2',
        name: {
          en: 'Standard',
        },
        description: {
          en: "The ideal package for newcomers. This package includes all the tools you'll need to quickly get your casino off the ground and running!",
        },
        imageUrl: '',
        price: 99,
        currency: 'USD',
        discount: 0,
        perks: [
          {
            name: {
              en: 'Loyalty & Shop - Silver',
            },
            description: {
              en: 'Players climb through the ranks for increasing benefits.',
            },
            imageUrl: 'https://micros-t.b-cdn.net/present-silver-1748016818460.svg',
          },
          {
            name: {
              en: 'Jackpot - Silver',
            },
            description: {
              en: 'Mystery jackpot starting with two prize tiers and increasing up to four as your volume increases.',
            },
            imageUrl: 'https://micros-t.b-cdn.net/piggy-silver-1748016818439.svg',
          },
          {
            name: {
              en: 'Tournaments (Casino + SB) - Bronze',
            },
            description: {
              en: 'Week-long tournament with a medium prize pool for top 100 players.',
            },
            imageUrl: 'https://micros-t.b-cdn.net/wheel-silver-1748016827522.svg',
            requirement: {
              name: {
                en: 'Requires Loyalty level 1 or better',
              },
              pack: 'loyalty_shop_1',
              level: 'level_1',
            },
          },
          {
            name: {
              en: 'Happy Hour (Casino + SB) - Silver',
            },
            description: {
              en: 'Improved Happy Hour with more prizes, awards a mix of cash and loyalty points.',
            },
            imageUrl: 'https://micros-t.b-cdn.net/shop-silver-1748016827512.svg',
            requirement: {
              name: {
                en: 'Requires Loyalty level 1 or better',
              },
              pack: 'loyalty_shop_1',
              level: 'level_1',
            },
          },
        ],
      },
      {
        id: 'traffic_pack_3',
        name: {
          en: 'Premium',
        },
        description: {
          en: "The ideal package for newcomers. This package includes all the tools you'll need to quickly get your casino off the ground and running!",
        },
        imageUrl: '',
        price: 179,
        currency: 'USD',
        discount: 0,
        perks: [
          {
            name: {
              en: 'Loyalty & Shop - Gold',
            },
            description: {
              en: 'Exclusive events to engage high value players.',
            },
            imageUrl: 'https://micros-t.b-cdn.net/present-gold-1748016818460.svg',
          },
          {
            name: {
              en: 'Jackpot - Gold',
            },
            description: {
              en: 'Pays daily and pays before value jackpots to attract jackpot hunters in a safe way.',
            },
            imageUrl: 'https://micros-t.b-cdn.net/piggy-gold-1748016818439.svg',
          },
          {
            name: {
              en: 'Tournaments (Casino + SB) - Gold',
            },
            description: {
              en: 'A separate two days long tournament to increase player stickiness on top of the week long event.',
            },
            imageUrl: 'https://micros-t.b-cdn.net/wheel-gold-1748016827519.svg',
            requirement: {
              name: {
                en: 'Requires Loyalty level 1 or better',
              },
              pack: 'loyalty_shop_1',
              level: 'level_1',
            },
          },
          {
            name: {
              en: 'Happy Hour (Casino + SB) - Gold',
            },
            description: {
              en: "Variable prizes increased bqy the player's Loyalty Rank",
            },
            imageUrl: 'https://micros-t.b-cdn.net/shop-gold-1748016827510.svg',
            requirement: {
              name: {
                en: 'Requires Loyalty level 1 or better',
              },
              pack: 'loyalty_shop_1',
              level: 'level_1',
            },
          },
          {
            name: {
              en: 'Wheel - Gold',
            },
            description: {
              en: 'Attractive jackpot size prize and new rules to reward players that return for for five days in a row.',
            },
            imageUrl: 'https://micros-t.b-cdn.net/time-gold-1748016827515.svg',
          },
        ],
      },
    ];

    setTimeout(() => resolve(data), RANDOM_MOCK_API_DELAY);
  });
}

// https://micros-t.b-cdn.net/card-gold-1748016818430.svg
// https://micros-t.b-cdn.net/cup-gold-1748016818436.svg

export function generateRandomOrderNumber(): string {
  const firstDigit = Math.floor(Math.random() * 9) + 1;

  let result = firstDigit.toString();

  for (let i = 0; i < 10; i++) {
    result += Math.floor(Math.random() * 10).toString();
  }

  return `WL_${result}`;
}
